// extracted by mini-css-extract-plugin
export default {"keywords":"Settings_keywords__eTD0J","each_keyword":"Settings_each_keyword__kYXq2","keywords_box":"Settings_keywords_box__UW5z2","settings":"Settings_settings__-SL6V"};